'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _overlay = require('./overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _handler = require('./handler');

var _handler2 = _interopRequireDefault(_handler);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function fixConfig(config) {
  if (!config) return;
  if ('model' in config && !('modal' in config)) {
    config.modal = config.model;
  }
}

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.items = [];
    this.maps = {};
    this.emitter = new _events2.default();
  }

  Manager.prototype.init = function init() {
    if (!document.body) {
      throw new Error('Must init in body');
    }

    if (this.inited) return;
    this.inited = true;

    if (this.tipHandler) {
      this.initEvent();
    }

    var div = document.createElement('div');
    div.className = 've-popups';
    document.body.appendChild(div);

    _reactDom2.default.render(_react2.default.createElement(_overlay2.default, { manager: this }), div);
  };

  Manager.prototype.initEvent = function initEvent() {
    var _this = this;

    document.addEventListener('mouseover', function (e) {
      return _this.tipHandler.setTarget(e.target);
    }, false);
    document.addEventListener('mousedown', function () {
      return _this.tipHandler.hideImmediately();
    }, true);
  };

  Manager.prototype.enableTip = function enableTip() {
    if (this.tipHandler) return;
    this.tipHandler = new _handler.TipHandler(this);
    if (this.inited) {
      this.initEvent();
    }
    this.emitter.emit('itemschange');
  };

  Manager.prototype.message = function message(config) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';

    if (typeof config === 'string') {
      config = {
        content: config
      };
    }
    fixConfig(config);
    var item = new _handler.MessageHandler(this, _extends({
      id: 1300,
      type: type
    }, config));
    this.addItem(item);
    return item;
  };

  Manager.prototype.success = function success(config) {
    return this.message(config, 'success');
  };

  Manager.prototype.error = function error(config) {
    return this.message(config, 'error');
  };

  Manager.prototype.warn = function warn(config) {
    return this.message(config, 'warn');
  };

  Manager.prototype.info = function info(config) {
    return this.message(config, 'info');
  };

  Manager.prototype.loading = function loading(config) {
    if (typeof config === 'string') {
      config = {
        content: config
      };
    }
    fixConfig(config);

    return this.popup(_extends({
      id: 1500,
      type: 'loading',
      modal: true,
      position: 'center center'
    }, config));
  };

  Manager.prototype.closeLoading = function closeLoading() {
    this.removeItem('1500');
  };

  Manager.prototype.clear = function clear() {
    this.items = [];
    this.maps = {};
    this.emitter.emit('itemschange');
  };

  Manager.prototype.confirm = function confirm(config) {
    if (typeof config === 'string') {
      config = {
        content: config
      };
    }

    var i = (0, _util.defer)();

    this.popup(_extends({
      id: 1200,
      type: 'confirm',
      modal: true,
      cancelOnBlur: !!config.target,
      actions: [{
        name: 'ok',
        title: config.confirmTitle || '好的',
        func: function func() {
          i.resolve();
          this.close();
        }
      }, {
        name: 'cancel',
        title: config.cancelTitle || '取消',
        func: function func() {
          i.reject();
          this.close();
        }
      }]
    }, config));

    return i.promise();
  };

  Manager.prototype.alert = function alert(config) {
    if (typeof config === 'string') {
      config = {
        content: config
      };
    }

    var i = (0, _util.defer)();

    this.popup(_extends({
      id: 1200,
      type: 'alert',
      actions: [{
        name: 'ok',
        title: config.confirmTitle || '好的',
        func: function func() {
          i.resolve();
          this.close();
        }
      }]
    }, config));

    return i.promise();
  };

  Manager.prototype.modal = function modal(config) {
    return this.popup(_extends({}, config, {
      modal: true
    }));
  };

  // 屎前巨坑


  Manager.prototype.model = function model(config) {
    this.modal(config);
  };

  Manager.prototype.removeItem = function removeItem(id) {
    var item = this.maps[id];
    if (item) {
      this.maps[id] = null;
      var i = this.items.indexOf(item);
      if (i > -1) {
        this.items.splice(i, 1);
        this.emitter.emit('itemschange');
      }
    }
  };

  Manager.prototype.addItem = function addItem(item) {
    var id = item.getId();

    this.removeItem(id);

    this.items.push(item);
    this.maps[item.getId()] = item;

    this.emitter.emit('itemschange');
  };

  Manager.prototype.popup = function popup(config) {
    fixConfig(config);
    var item = new _handler2.default(this, _extends({
      id: 1100,
      type: 'popup',
      position: config.target ? 'top' : 'center center'
    }, config));

    this.addItem(item);

    return item;
  };

  Manager.prototype.isShowMask = function isShowMask() {
    return this.items.some(function (item) {
      return item.isModal();
    });
  };

  Manager.prototype.getItems = function getItems() {
    if (this.tipHandler) {
      return [].concat(_toConsumableArray(this.items), [this.tipHandler]);
    }
    return this.items;
  };

  Manager.prototype.onItemsChange = function onItemsChange(func) {
    var _this2 = this;

    this.emitter.on('itemschange', func);
    return function () {
      _this2.emitter.removeListener('itemschange', func);
    };
  };

  return Manager;
}();

exports.default = Manager;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/manager.js
// module id = 283
// module chunks = 0